import { Container } from '@/components';
import { useEstimatedArrival } from '@/context/estimatedArrival/EstimatedArrivalContextProvider';
import { useSalesFileContext } from '@/context/salesFileContext/SalesFileContextProvider';
import React, { useState, useEffect } from 'react';
import { Dropdown } from '@/components';

const EstimateArrivalReport = () => {
  const { getWhrehouseListAPI, warehouseList } = useSalesFileContext();
  const { downloadETAFileReportAPI } = useEstimatedArrival();
  const warehouses = warehouseList || [];

  useEffect(() => {
    getWhrehouseListAPI();
  }, []);

  const [selectedWarehouses, setSelectedWarehouses] = useState([]);

  // Convert warehouses to array of objects with value/label for Dropdown
  const warehouseOptions = (warehouses || []).map((w, idx) => ({
    value: idx,
    label: w,
  }));

  const handleExport = () => {
    if (selectedWarehouses.length === 0) {
      alert('Please select at least one warehouse to export.');
    } else {
      const whseList = {
        whseList: selectedWarehouses.map((index) => warehouses[index]),
      };
      downloadETAFileReportAPI(whseList);
    }
  };

  return (
    <Container title="Estimate Arrival Report">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg mx-auto my-20">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Estimate Arrival Report
        </h2>
        <p className="text-gray-600 mb-6">
          Select warehouses to generate the estimate arrival report.
        </p>

        {/* Multi-select Dropdown using generic Dropdown component */}
        <Dropdown
          multiSelect
          options={warehouseOptions}
          selected={selectedWarehouses}
          onChange={setSelectedWarehouses}
          placeholder="Select Warehouses"
        />

        {/* Export Button */}
        <button
          onClick={handleExport}
          className={`mt-6 w-full py-2 px-4 text-white font-medium rounded-md shadow ${
            selectedWarehouses.length > 0
              ? 'bg-blue-600 hover:bg-blue-700'
              : 'bg-gray-400 cursor-not-allowed'
          }`}
          disabled={selectedWarehouses.length === 0}
        >
          Export Report
        </button>
      </div>
    </Container>
  );
};

export default EstimateArrivalReport;
